import React from "react"
import { Link } from "gatsby"


export default () => 
    <Link className="button is-outlined" to="/">
        На главную&rarr;
    </Link>